import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useState, useEffect } from 'react';

var spinner = "Spinner-module_spinner__DQ-68";
var spin = "Spinner-module_spin__DmjIz";
var small = "Spinner-module_small__O3e6i";
var large = "Spinner-module_large__UgXJT";
var Spinner_module = {"spinner":"Spinner-module_spinner__DQ-68","spin":"Spinner-module_spin__DmjIz","small":"Spinner-module_small__O3e6i","large":"Spinner-module_large__UgXJT"};

var styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: Spinner_module,
  large: large,
  small: small,
  spin: spin,
  spinner: spinner
});

const Spinner = ({ className, size = "small", ...otherProps }) => {
    return (jsx("span", { className: classNames(spinner, styles[size], className), ...otherProps }));
};

const DelayedSpinner = ({ delayInMs = 1000, ...spinnerProps }) => {
    const [isDelayComplete, setIsDelayComplete] = useState(false);
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsDelayComplete(true);
        }, delayInMs);
        return () => clearTimeout(timeoutId);
    }, [delayInMs]);
    return isDelayComplete ? jsx(Spinner, { ...spinnerProps }) : null;
};

export { DelayedSpinner, Spinner };
